export const REGEX = {
    mobileNumberRegex:/(\d{0,3})(\d{0,3})(\d{0,4})/,
   //First Name  and LastName to start with alphabet and then special characters '.- to be allowed max 2 each             
    sendName: /^(?=[A-Za-z])(?=[^+(),*]*$)(?=(?:[^.]*\.){0,2}[^.]*$)(?=(?:[^-]*-){0,2}[^-]*$)(?=(?:[^']*'){0,2}[^']*$)(?=(?:[^ ]* ){0,2}[^ ]*$)[A-Za-z][A-Za-z .'-]*$/,
    sendLname: /^(?=[A-Za-z])(?=[^+(),*]*$)(?=(?:[^.]*\.){0,2}[^.]*$)(?=(?:[^-]*-){0,2}[^-]*$)(?=(?:[^']*'){0,2}[^']*$)(?=(?:[^ ]* ){0,2}[^ ]*$)[A-Za-z][A-Za-z .'-]*$/, // Last Name
    sendZip: /^(\d{5}(-\d{4})?|[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d|[A-Za-z]\d[A-Za-z])$/, // Zip Code
    sendPhone: /^(\+?[1-9]\d{1,14}|0)$/, // Phone Number
    sendEmail: /^(([^<>()[\]\\.,;:\s@"#]+(\.[^<>()[\]\\.,;:\s@"#]+)*)|("[^"]+"))@((\[(25[0-5]|2[0-4]\d|1\d\d|\d{1,2})(\.(25[0-5]|2[0-4]\d|1\d\d|\d{1,2})){3}\])|(([a-z\d]([a-z\d\-]*[a-z\d])?\.)+[a-z]{2,}))$/i,// Email Address
    sendAddress1:/^[^\s!@#$%^&*()].*$/, // Address Line 1
    sendAddress2:/^[^!@#$%^&*()].*$/, // Address Line 2 (optional)
    sendCity: /^[A-Za-z][A-Za-z ]*$/, // City
    sendCaPostalCode:/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,//handle the space in zipcode for tech availibility api,
    matchAny: /^(?=.*\S).+$/,
    sendNumber: /^[0-9]+$/,
    sendYear: /^\d{4}$/,
    allow3Digit: /^(?:[5-9]\d{2}|[1-9]\d{3,4})$/,
    allow1to9:  /^[1-9]$/,
    allow1to99: /^(?:[1-9]|[1-9][0-9]?)$/,
    floatDigit: /^\d+(\.\d+)?$/,
    caSendZip: /^(3|5|\d{3}|\d{5}|[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d|[A-Za-z]\d[A-Za-z]|[A-Za-z]+(?: [A-Za-z]+)*)$/,
    allow1to99999Digit: /^[1-9]\d{0,4}$/,
    caPostalCodeFSA: /^[A-Z]\d[A-Z]$/, // CA FSA format: M5V
    caPostalCodeFull: /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/, // CA 6-digit format: M5V3L9 or M5V 3L9
    usZipCode: /^\d{5}(-\d{4})?$/, // US ZIP: 12345 or 12345-6789
    noBracketAddress: /^[^!?@#$%^&*()]*$/,
    alphanumeric: /^[a-zA-Z0-9]+$/,
    // dateMMDDYYYY: /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/,
    dateMMDDYYYY: /^(0[1-9]|1[0-2])\s*\/\s*(0[1-9]|[12][0-9]|3[01])\s*\/\s*\d{4}$/,
    agentAgencyName: /^[A-Za-z][A-Za-z' .-]{0,399}$/

    
}

export function validateLocalZipPostalCode(postal: any): boolean {
    const urlParts = window.location.href.toLowerCase().split('/');
    const countryCode = urlParts[3] === "ca" ? "ca" : "us";

    if (typeof postal !== "string") {
        postal = postal.toString();
    }

    postal = postal.trim().toUpperCase();

    if (countryCode === 'ca') {
        // Canadian postal code: A1A 1A1 or A1A1A1
        return /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/.test(postal);
    }

    if (countryCode === 'us') {
        // US ZIP: 12345 or 12345-6789
        return /^\d{5}(-\d{4})?$/.test(postal);
    }

    return false;
}
